import React from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CashierApi from "../../utility/CashierApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { clearOfflineItems, getOfflineCart } from "../../utility/offline/offlineCart";
import { isOffline } from "../../utility/offline/reachability";

function ClearCart({ id }) {
  const { fetchOnlyData } = CashierApi();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async () => {
      const clearLocally = () =>
        clearOfflineItems(id, queryClient.getQueryData(["cart", id]));
      if (isOffline() || getOfflineCart(id)) return clearLocally();
      try {
        return await fetchOnlyData(`carts/clear-cart/${id}`);
      } catch (error) {
        if (error?.isNetworkError) return clearLocally();
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cart"] }); // Refresh relevant queries
    },
    // onError: (error) => {
    //   console.error("Error clearing cart:", error);
    // },
  });

  const handleDelete = () => {
    mutation.mutate();
  };

  return (
    <div>
      <DeleteForeverIcon
        sx={{ fontSize: "40px" }}
        className="text-red-600 cursor-pointer"
        onClick={handleDelete}
      />
    </div>
  );
}

export default ClearCart;
